
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23.022","height":"14.8"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"a",attrs:{"fill":"#FFF","d":"M22.632 1.767a.822.822 0 00-.8-.036l-5.388 2.694V2.467A2.467 2.467 0 0013.977 0H2.467A2.467 2.467 0 000 2.467v9.867a2.467 2.467 0 002.467 2.467h11.511a2.467 2.467 0 002.467-2.467v-1.959l5.388 2.7a.822.822 0 001.19-.74V2.467a.822.822 0 00-.391-.7zM14.8 12.333a.822.822 0 01-.822.822H2.467a.822.822 0 01-.822-.822V2.467a.822.822 0 01.822-.822h11.511a.822.822 0 01.822.822v9.867zm6.578-1.33l-4.933-2.467V6.267L21.378 3.8z"}}),_c('path',{staticClass:"a",attrs:{"fill":"#FFF","d":"M8.222 4.111A3.289 3.289 0 1011.511 7.4a3.289 3.289 0 00-3.289-3.289zm0 4.933A1.644 1.644 0 119.866 7.4a1.644 1.644 0 01-1.644 1.644z"}})])
          )
        }
      }
    